import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import format from "date-fns/format";
import { StartCase } from "react-lodash";
import _ from "lodash";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import { Pagination } from "../../../Utils";
import {
  Confirmation,
  ErrorToast,
  SuccessToast,
} from "../../../Utils/SweetAlert";
import parse from "html-react-parser";
import {
  DeleteFaqs,
  GetFaqsPaginate,
  ChangeStatus,
} from "../../../Services/Api/faq";

const FaqList = () => {
  // const parse = require('html-react-parser');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [faqData, setFaqData] = useState([]);
  const navigate = useNavigate();

  const GetFaq = async (limitO = "", pageO = "") => {
    setIsLoading(true);
    await GetFaqsPaginate({ limit: limitO, page: pageO })
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.data?.totalRecords > 0) {
          setFaqData(res?.data?.data?.faqs);
          setTotalRecords(res?.data?.data?.totalRecords);
        } else {
          setFaqData([]);
          setTotalRecords(0);
        }
      })
      .catch((err) => {
        setFaqData([]);
        setTotalRecords(0);
        setIsLoading(false);
      });
  };

  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
    await GetFaq(limit, pageNew);
  };

  const handleLimitChange = async (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    await GetFaq(parseInt(event.target.value, 10), 0);
  };

  const changeStatus = (faqs, text) => {
    Confirmation(text).then(async (result) => {
      if (result.isConfirmed) {
        const postObj = {
          id: faqs._id,
          status: `${faqs.status ^ 1}`,
        };
        await ChangeStatus(postObj)
          .then((res) => {
            SuccessToast(res?.data.message || "Status Updated");
            GetFaq(limit, page);
          })
          .catch((err) => {
            // if (typeof err.response.data.message !== "undefined") {
            //   ErrorToast(err.response.data.message || "Server Error!!");
            // } else {
            //   ErrorToast(err?.message || "Server Error!!");
            // }
          });
      }
    });
  };

  const deleteFaqs = (faqsId) => {
    Confirmation("Want to delete faqs?").then(async (deleteConfirm) => {
      if (deleteConfirm.isConfirmed) {
        await DeleteFaqs(faqsId)
          .then((res) => {
            SuccessToast(res?.data?.message || "Faqs Deleted.");
            GetFaq(limit, page);
          })
          .catch((err) => {
            // if (typeof err.response.data.message !== "undefined") {
            //   ErrorToast(err.response.data.message || "Server Error!!");
            // } else {
            //   ErrorToast(err?.message || "Server Error!!");
            // }
          });
      }
    });
  };

  useEffect(() => {
    GetFaq(limit, page);
  }, [limit, page]);

  return (
    <>
      <Helmet>
        <title>CPay | Admin - Faq</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Faq</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Faq</li>
                </ul>
              </div>
              <div className="col-auto">
                <Link to="/admin/add-faq" className="btn btn-primary me-1">
                  <i className="fas fa-plus" /> Add Faq
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive custom-pagination">
                    <table className="table table-center table<img<image-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>Type</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                          <th>Question</th>
                          <th>Answer</th>
                          <th>Created On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading && (
                          <>
                            {faqData.map((faqs, index) => (
                              <tr key={index}>
                                <td>
                                  {
                                    <StartCase
                                      string={_.replace(faqs?.type, "_", " ")}
                                    />
                                  }
                                </td>
                                <td>
                                  {faqs?.status === 0 && (
                                    <button
                                      className="btn btn-sm  btn-block btn-outline-danger"
                                      onClick={() => {
                                        changeStatus(
                                          faqs,
                                          "Want to active faqs?"
                                        );
                                      }}
                                    >
                                      Inactive
                                    </button>
                                  )}
                                  {faqs?.status === 1 && (
                                    <button
                                      className="btn btn-sm  btn-block btn-outline-success"
                                      onClick={() => {
                                        changeStatus(
                                          faqs,
                                          "Want to deactivate faqs?"
                                        );
                                      }}
                                    >
                                      Active
                                    </button>
                                  )}
                                </td>
                                <td className="text-center">
                                  <Tooltip
                                    title="Edit"
                                    className="btn btn-sm btn-white text-success me-2"
                                    onClick={() =>
                                      navigate("/admin/edit-faq", {
                                        state: { id: faqs?._id },
                                      })
                                    }
                                  >
                                    <IconButton>
                                      <EditIcon />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip
                                    title="Delete"
                                    className="btn btn-sm btn-white text-danger me-2"
                                    onClick={() => deleteFaqs(faqs?._id)}
                                  >
                                    <IconButton>
                                      <DeleteIcon />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                                <td>{faqs.question || "-"}</td>
                                <td>{parse(faqs.answer) || "-"}</td>

                                <td>
                                  {format(
                                    new Date(faqs?.createdAt),
                                    "dd MMMM, yyyy"
                                  )}
                                </td>
                              </tr>
                            ))}
                            {faqData.length === 0 && (
                              <tr>
                                <td colSpan={12}>No Records Found.</td>
                              </tr>
                            )}
                          </>
                        )}

                        {isLoading && (
                          <tr>
                            <td align="center" colSpan={12}>
                              Loading...
                            </td>
                          </tr>
                        )}

                        <Pagination
                          totalItem={totalRecords}
                          itemsPerPage={limit}
                          page={page}
                          handleChangePage={handlePageChange}
                          handleChangeRowsPerPage={handleLimitChange}
                          colSpan={12}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class=" container-fluid absolute mb-4">
              <footer className="text-center text-lg-start">
                <div className="text-center">Powered by Alsaffron System.</div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqList;
